import type { InterventionSectionTagProps } from "./intervention-section-tag.type";

import { Tag } from "@/ui/tag";

import { useInterventionSectionTag } from "./intervention-section-tag.hook";

import "./intervention-section-tag.style.less";

const InterventionSectionTag = ({ section }: InterventionSectionTagProps) => {
  const attributes = useInterventionSectionTag(section);

  if (!attributes) return null;

  const { color, icon, content } = attributes;

  return (
    <Tag color={color} icon={icon} className="intervention-section-tag">
      {content}
    </Tag>
  );
};

export default InterventionSectionTag;
